import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import { Container } from "components/misc/Layouts";

export default () => {
  const Subheading = tw.span`tracking-wider text-sm font-medium`;
  const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
  const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
  const Description = tw.span`inline-block mt-8`;
  const SingleColumn = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
  const imageCss = tw`rounded-4xl`;
  return (
    <AnimationRevealPage>
      <Header />
      <Hero
        heading={<>Thursdays 7-9pm <HighlightedText>at the Hub</HighlightedText></>}
        description="Parking is available on Piercefield Ln and Heol-Y-Bont."
        imageSrc="https://penparcau.cymru/wp-content/uploads/2020/02/Hwb-1-1024x685.jpg"
        imageCss={imageCss}
        imageDecoratorBlob={true}
        primaryButtonText="See Calendar"
        watchVideoButtonText="Message From "
      />
      <Container>
        <SingleColumn>
          <iframe
            width="100%"
            height="450"
            style={{border:0}}
            loading="lazy"
            allowfullscreen
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2434.3409577948064!2d-4.073925723058012!3d52.40049654506994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x486f765d1da2ef43%3A0x1922fcb2a2f4aa8d!2sThe%20Hub%20-%20Penparcau%20Community%20Centre!5e0!3m2!1sen!2suk!4v1739309963028!5m2!1sen!2suk">
          </iframe>
        </SingleColumn>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
}
